import { reportConstants } from '../../../../constants/reports';

const playerBasicFields = [
	{
		label: reportConstants.REPORT_PLAYER_ID,
		key: reportConstants.COLUMN_PLAYER_ID,
	},
	{
		label: reportConstants.REPORT_EXT_PLAYER_ID,
		key: reportConstants.COLUMN_EXT_PLAYER_ID,
	},
	{
		label: reportConstants.REPORT_USERNAME,
		key: reportConstants.COLUMN_USERNAME,
	},
	{
		label: reportConstants.REPORT_NIKNAME,
		key: reportConstants.COLUMN_NIKNAME,
	},
	{
		label: reportConstants.REPORT_VIP_LEVEL,
		key: reportConstants.COLUMN_VIP_LEVEL,
	},
	{
		label: reportConstants.REPORT_CURRENCY,
		key: reportConstants.COLUMN_CURRENCY,
		isCurrency: false,
	},
];
const playerPersonalFields = [
	{
		label: reportConstants.REPORT_FIRST_NAME,
		key: reportConstants.COLUMN_FIRST_NAME,
	},

	{
		label: reportConstants.REPORT_LAST_NAME,
		key: reportConstants.COLUMN_LAST_NAME,
	},
	{
		label: reportConstants.REPORT_STATE,
		key: reportConstants.COLUMN_STATE,
	},

	{
		label: reportConstants.REPORT_CITY,
		key: reportConstants.COLUMN_CITY,
	},
	{
		label: reportConstants.REPORT_EMAIL,
		key: reportConstants.COLUMN_EMAIL,
	},
	{
		label: reportConstants.REPORT_COUNTRY,
		key: reportConstants.COLUMN_COUNTRY,
		isCurrency: false,
	},
];
const playerActivityFields = [
	{
		label: reportConstants.REPORT_FIRST_ACTIVITY,
		key: reportConstants.COLUMN_FIRST_ACTIVITY,
	},

	{
		label: reportConstants.REPORT_LAST_ACTIVITY,
		key: reportConstants.COLUMN_LAST_ACTIVITY,
	},
	{
		label: reportConstants.REPORT_LIFETIME_BET,
		key: reportConstants.COLUMN_LIFETIME_BET,
		isCurrency: true,
	},
	{
		label: reportConstants.REPORT_LIFETIME_WIN,
		key: reportConstants.COLUMN_LIFETIME_WIN,
		isCurrency: true,
	},
	{
		label: reportConstants.REPORT_LIFETIME_GGR,
		key: reportConstants.COLUMN_LIFETIME_GGR,
		isCurrency: true,
	},
	{
		label: reportConstants.REPORT_LAST_KNOWN_IP,
		key: reportConstants.COLUMN_LAST_KNOWN_IP,
		isCurrency: false,
	},
];
const playerBonusFields = [
	{
		label: reportConstants.REPORT_REAL_BONUS_BALANCE,
		key: reportConstants.COLUMN_REAL_BONUS_BALANCE,
		isCurrency: true,
	},
	{
		label: reportConstants.REPORT_REAL_BONUS_AWARDED,
		key: reportConstants.COLUMN_REAL_BONUS_AWARDED,
		isCurrency: true,
	},

	{
		label: reportConstants.REPORT_REAL_BONUS_EXPIRED,
		key: reportConstants.COLUMN_REAL_BONUS_EXPIRED,
		isCurrency: true,
	},
];

export { playerActivityFields, playerBasicFields, playerBonusFields, playerPersonalFields };
